import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store/index';
import { setCurrentCategoryAction } from 'store/category/slice';
import { AppBundle } from 'api/optimalprint-sdk.d';

const setCurrentCategoryOperation =
  (category: AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response) =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>) => {
    dispatch(setCurrentCategoryAction(category));
  };

export default setCurrentCategoryOperation;
